import { createSlice } from "@reduxjs/toolkit";

const dailyUpdateSlice = createSlice({
    name: "dailyUpdate",
    initialState:{
        myDailyUpdates: [],
        todayFeed: {date: null , count:0, dailyUpdates:[]} , // admin
        loading: false,
        error: null,
    },
    reducers:{
        startLoading(state){
            state.loading = true;
            state.error = null;
        },
        stopLoading(state){
            state.loading = false;
        },
        setMyDailyUpdates(state, action){
            state.myDailyUpdates = action.payload;
            state.loading = false;
        },
        upsertMyDailyUpdate(state, action){
            const item = action.payload;
            const idx = state.myDailyUpdates.findIndex((x)=> x._id === item._id);
            if(idx >=0) state.myDailyUpdates[idx] = item;
            else state.myDailyUpdates.unshift(item);
            state.loading = false;
        },
        setTodayFeed(state,action){
            state.todayFeed = action.payload;
            state.loading = false;
        },
        setError(state,action){
            state.error = action.payload;
            state.loading = false;
        },
        clearDailyUpdates(state){
            state.myDailyUpdates = [];
            state.todayFeed= {date: null, count: 0, dailyUpdates:[]};
            state.loading =false;
            state.error = null;
        },
    },
});

const dailyUpdateReducer = dailyUpdateSlice.reducer;
const dailyUpdateActions = dailyUpdateSlice.actions;
export { dailyUpdateActions, dailyUpdateReducer };